import { useStore } from '../../store/useStore';
import { shopItems } from '../../data/shopItems';
import { useEffect } from 'react';

export const ShopUI = () => {
    const {
        isShopOpen,
        toggleShop,
        gold,
        inventory,
        buyItem,
        sellItem
    } = useStore();

    useEffect(() => {
        // Close on Escape
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && isShopOpen) {
                toggleShop();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isShopOpen, toggleShop]);

    if (!isShopOpen) return null;

    // Filter items player can sell (items with value > 0 or default logic)
    // For now, everything in inventory is sellable
    const sellableItems = inventory;

    return (
        <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(5px)',
            pointerEvents: 'auto',
            zIndex: 2000
        }}>
            <div className="shop-container" style={{
                display: 'flex',
                gap: '20px',
                width: '800px',
                height: '500px',
                background: 'rgba(20, 20, 30, 0.95)',
                border: '2px solid #daa520',
                borderRadius: '12px',
                boxShadow: '0 0 40px rgba(218, 165, 32, 0.2)',
                padding: '20px',
                color: '#ecf0f1',
                fontFamily: "'Inter', sans-serif",
                position: 'relative'
            }}>

                {/* Close Button */}
                <button
                    onClick={toggleShop}
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        background: '#e74c3c',
                        border: 'none',
                        color: '#fff',
                        fontSize: '16px',
                        cursor: 'pointer',
                        width: '30px',
                        height: '30px',
                        borderRadius: '4px',
                        pointerEvents: 'auto',
                        fontWeight: 'bold',
                        padding: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#c0392b';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#e74c3c';
                    }}
                >✕</button>

                {/* Left: Buy */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: '20px', borderRight: '1px solid rgba(255,255,255,0.1)' }}>
                    <h2 style={{ borderBottom: '1px solid #daa520', paddingBottom: '10px', color: '#daa520' }}>Merchant's Goods</h2>
                    <div className="shop-list" style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '5px' }}>
                        {shopItems.map(item => (
                            <div key={item.id} style={{
                                display: 'flex',
                                alignItems: 'center',
                                background: 'rgba(255,255,255,0.05)',
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid rgba(255,255,255,0.1)'
                            }}>
                                <div style={{ fontSize: '24px', marginRight: '10px' }}>{item.icon || '📦'}</div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 'bold' }}>{item.name}</div>
                                    <div style={{ fontSize: '12px', opacity: 0.7 }}>{item.description}</div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '5px' }}>
                                    <div style={{ color: gold >= item.cost ? '#ffd700' : '#e74c3c', fontWeight: 'bold' }}>{item.cost}g</div>
                                    <button
                                        onClick={() => buyItem(item.id)}
                                        disabled={gold < item.cost}
                                        style={{
                                            background: gold >= item.cost ? '#27ae60' : '#555',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '4px 12px',
                                            borderRadius: '4px',
                                            cursor: gold >= item.cost ? 'pointer' : 'not-allowed',
                                            fontSize: '12px'
                                        }}
                                    >
                                        Buy
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right: Sell */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingLeft: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #777', paddingBottom: '10px' }}>
                        <h2>Your Inventory</h2>
                        <div style={{ color: '#ffd700', fontWeight: 'bold', fontSize: '18px' }}>💰 {gold}g</div>
                    </div>

                    <div className="inventory-list" style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '5px', marginTop: '10px' }}>
                        {sellableItems.length === 0 ? (
                            <div style={{ opacity: 0.5, textAlign: 'center', marginTop: '40px' }}>Your pockets are empty.</div>
                        ) : (
                            sellableItems.map(item => (
                                <div key={item.id} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: 'rgba(0,0,0,0.2)',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255,255,255,0.05)'
                                }}>
                                    <div style={{ fontSize: '24px', marginRight: '10px' }}>{item.icon || '📦'}</div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: 'bold' }}>{item.name}</div>
                                        <div style={{ fontSize: '10px', opacity: 0.5 }}>ID: {item.id.substr(0, 4)}</div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '5px' }}>
                                        <div style={{ color: '#ffd700', fontSize: '12px' }}>+{item.value || 10}g</div>
                                        <button
                                            onClick={() => sellItem(item.id)}
                                            style={{
                                                background: '#d35400',
                                                color: '#fff',
                                                border: 'none',
                                                padding: '4px 12px',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontSize: '12px'
                                            }}
                                        >
                                            Sell
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
